<template>
  <div>
    <v-card class="fullForm">
      <div class="fullText">
        <h3>
          جهت انتقال به حوزه های علمیه قم و استان های تابعه (بجز اصفهان)،
          خواهشمند تذكرات ذيل را با دقت مطالعه نماييد:
        </h3>
        <br />
        <ul>
          <li>
            انتقال طلاب متاهل به مدارس علمیه استان قم منوط به اتمام حداقل سطح یک
            می باشدو برای طلاب مجرد، اتمام پایه ده کتبی ضروری خواهد بود
          </li>
          <li>
            جهت انتقال به استان های تابعه مرکز مدیریت حوزه های علمیه قم، حداقل
            اتمام پایه یک ضروری است
          </li>
          <li>
            زمان درخواست انتقال به قم از  اول مرداد ماه تا 15 شهريور ماه خواهد بود و
            به ‏درخواستهاي بعد از اين تاريخ ترتيب اثر داده نخواهد شد
          </li>
          <li>
            درخواست شما بعد از تائید مدرسه مبدا و مرکز مدیریت خراسان، بصورت
            سیستمی برای مرکز مدیریت قم ارسال خواهد شد و شما می توانید در بخش
            مشاهده سوابق آخرین وضعیت درخواست خود را مشاهده نمائید.
          </li>
          <li>
            در صورت موافقت اولیه قم با درخواست شما، می بایست جهت انجام مراحل
            تسویه به مدرسه مبدا و سپس به مرکز مدیریت خراسان مراجعه فرمائید.
          </li>
        </ul>
        <br />
        <div class="fullText">
          همچنین برای راهنمای انتقال به قم می توانید به لینک زیر مراجعه فرمایید.
          <br />
          <br />
          <a
            target="_blank"
            href="https://hozehkh.com/res/qom_help.pdf"
            style="display: block"
          >
            راهنمای انتقال به قم
          </a>
        </div>
      </div>
    </v-card>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="12">
          لطفا استان و شهر را انتخاب کنید:
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="2">
          <b>استان:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <v-select
            :items="Object.keys(schools)"
            v-model="ostan"
            @change="updateCity"
            no-data-text="داده ای برای نمایش وجود ندارد."
          ></v-select>
        </v-col>

        <v-col class="d-flex" cols="12" sm="2">
          <b>شهر:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <v-select
            :items="cities"
            v-model="shahr"
            no-data-text="داده ای برای نمایش وجود ندارد."
          ></v-select>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="form-2">
      <v-checkbox
        v-for="(school, index) in citySchools"
        :key="index"
        v-model="selected"
        :label="school.ID + '- ' + school.Name"
        :value="school.ID"
      ></v-checkbox>
    </v-card>
    <div class="confirm" v-if="selected.length > 0">
      <v-btn
        class="register"
        :class="!isMobile ? 'btnMargin' : ''"
        color="primary white--text"
        rounded
        @click="sendRequest"
      >
        ثبت
      </v-btn>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { transferToQomRequest } from "@/api/transfer";
export default {
  created() {
    this.$store.dispatch("getActiveSchools", false).then(() => {
      if (Object.keys(this.schools).length > 0) {
        this.ostan = Object.keys(this.schools)[0];
        this.shahr = Object.keys(this.schools[this.ostan])[0];
      }
    });
  },
  methods: {
    updateCity() {
      this.selected = [];
      this.shahr = Object.keys(this.schools[this.ostan])[0];
    },
    sendRequest() {
      /**
       * call api
       */
      transferToQomRequest(this.selected)
        .then((response) => {
          const data = response.data;
          this.$router.push({ path: "/index" });
          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
        })

        .catch((error) => {});
    },
  },
  computed: {
    schools() {
      return this.$store.getters.schools;
    },
    cities() {
      return this.schools.hasOwnProperty(this.ostan)
        ? Object.keys(this.schools[this.ostan])
        : [];
    },
    citySchools() {
      return this.schools.hasOwnProperty(this.ostan)
        ? this.schools[this.ostan].hasOwnProperty(this.shahr)
          ? this.schools[this.ostan][this.shahr]
          : []
        : [];
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  data() {
    return {
      ostan: "",
      shahr: "",
      selected: [],
    };
  },
};
</script>
<style>
.v-input--checkbox label {
  direction: rtl !important;
}
</style>
<style scoped>
.form-2 {
  padding: 10px 20px;
  display: flow-root;
}

.v-input--checkbox {
  float: right;
  width: 100%;
  margin: 10px 0;
  padding-top: 0px;
}

@media (max-width: 768px) {
  .col-sm-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (min-width: 768px) {
  .v-input--checkbox {
    width: 50%;
  }
}

@media (min-width: 1280px) {
  .v-input--checkbox {
    width: 33.3%;
  }
}

@media (min-width: 1600px) {
  .v-input--checkbox {
    width: 25%;
  }
}
</style>
